import { render } from "./NeurologicalDiseaseView.vue?vue&type=template&id=c096a40c"
import script from "./NeurologicalDiseaseView.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__